import { render, staticRenderFns } from "./LoginAdmin.vue?vue&type=template&id=047b4d6e"
import script from "./LoginAdmin.vue?vue&type=script&lang=js"
export * from "./LoginAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports